import { SuperModel } from './super-model.model';

export class News extends SuperModel {
  title: string;
  body: string;
  showPopup: boolean;
  publishedFrom: Date;
  publishedTo: Date;

  constructor(data: Partial<News> = {}) {
    super(data);

    if (data.publishedFrom) {
      this.publishedFrom = new Date(data.publishedFrom);
    }
    if (data.publishedTo) {
      this.publishedTo = new Date(data.publishedTo);
    }
  }

  get formattedBody() {
    let newBody = this.body.replace('<br>', '');
    newBody = newBody.replace('</br>', '');
    return newBody;
  }

  get serialised() {
    if (this.publishedFrom) {
      this.publishedFrom.setHours(12, 0, 0);
    }
    if (this.publishedTo) {
      this.publishedTo.setHours(12, 0, 0);
    }
    return {
      id: this.id,
      title: this.title,
      body: this.body,
      showPopup: this.showPopup,
      publishedFrom: this.publishedFrom,
      publishedTo: this.publishedTo,
    };
  }
}
